export default __webpack_public_path__ + "static/media/4.8c93ea0d.mp3";